import { render, staticRenderFns } from "./FullSlideImage.vue?vue&type=template&id=003aa09d&scoped=true&"
import script from "./FullSlideImage.vue?vue&type=script&lang=js&"
export * from "./FullSlideImage.vue?vue&type=script&lang=js&"
import style0 from "./FullSlideImage.vue?vue&type=style&index=0&id=003aa09d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003aa09d",
  null
  
)

export default component.exports